import React, { useState } from "react";
import { Marker, Popup } from "react-map-gl/mapbox";
import iconTruck from "../assets/AT_l.png";
import iconShovel from "../assets/excavator.png";
import iconDozer from "../assets/dozerIcon.png";
import iconGrader from "../assets/graderIcon.png";


const GpsPositionMarker = ({ coordinates, markerName, isActive, onClick, angle, equipmentType }) => {
  const [showPopup, setShowPopup] = useState(false);

  const config = {
    Shovel: { src: iconShovel, className: "w-5 h-14" },
    Truck: { src: iconTruck, className: "w-4 h-10" },
    Dozer: { src: iconDozer, className: "w-7 h-11" },
    Grader: { src: iconGrader, className: "w-12 h-8" },
    Loader: { src: iconDozer, className: "w-7 h-11" },
    Backhoe: { src: iconDozer, className: "w-7 h-11" },
  };

  // Si no existe el tipo, usa uno por defecto
  const { src, className } = config[equipmentType] || {
    src: iconTruck,
    className: "w-6 h-8",
  };

  const handleClick = (e) => {
    e.stopPropagation(); // evita que el click se propague al mapa
    setShowPopup(!showPopup);
  };

  return (
    <>
      <Marker
        key={markerName}
        longitude={coordinates.longitude}
        latitude={coordinates.latitude}
        anchor="center"
      >
        <div className="flex flex-col items-center cursor-pointer">
          <img
            src={src}
            className={className}
            alt={markerName}
            style={{ transform: `rotate(${angle}deg)` }}

          />
          <div
            className="px-1 py-0.5 bg-black text-white rounded shadow text-xs text-center"
          >
            {markerName}
          </div>
        </div>
      </Marker>

      {/* Popup al hacer click */}
      {showPopup && (
        <Popup
          longitude={coordinates.longitude}
          latitude={coordinates.latitude}
          anchor="top"
          closeOnClick={true}
          closeButton={false}
        >
          <div className="text-sm">
            <strong>{markerName}</strong>
            <p></p>
          </div>
        </Popup>
      )}
    </>
  );
};

export default GpsPositionMarker;
